import { render } from "./FacturacionFormaPago.vue?vue&type=template&id=5854ebec&scoped=true"
import script from "./FacturacionFormaPago.vue?vue&type=script&lang=js"
export * from "./FacturacionFormaPago.vue?vue&type=script&lang=js"

import "./FacturacionFormaPago.vue?vue&type=style&index=0&id=5854ebec&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5854ebec"]])

export default __exports__